import moment from 'moment';

export const MASCARA_ISO_HHMM_Z = 'YYYY-MM-DDTHH:mmZ';
export const MASCARA_DDMMYYYY = 'DD-MM-YYYY';
export const MASCARA_YYYYMMDD = 'YYYY-MM-DD';
// No es poden mostrar observacions anteriors a aquesta data
export const dataPassatNoMostrarSelectorObservacions = '2009-01-01T00:00+00:00';

/**
 * Crea un objecte moment a partir d'un string. Si el string no te el formate 'YYYY-MM-DDTHH:mmZ', es pot especificar una mascara
 * per la creació.
 *
 * @param dataAstext
 * @param mascara
 * @return {Moment}
 */
export const convertirTextAMomentUTC = (dataAsText, mascara = MASCARA_ISO_HHMM_Z) => {
    var dateMoment = moment.utc(dataAsText, mascara, true);

    if (!dateMoment.isValid()) {
        //TODO: tractar error al crear una data invalida
        console.error('Data invàlida. Valor:', dataAsText);
        return null;
    }

    return dateMoment;
};

/**
 * Crea un objecte {Moment} a partir d'un string. Si el string no té el format 'YYYY-MM-DDTHH:mmZ',
 * es pot especificar una màscara per la creació.
 *
 * @param dataAstext
 * @param mascara
 * @return {Moment}
 */
export const convertirTextAMomentLocal = (dataText, mascara = MASCARA_ISO_HHMM_Z) => {
    var data = moment(dataText, mascara, true);

    if (!data.isValid()) {
        //TODO: tractar error al crear una data invàlida
        console.error('Data invàlida. Valor:', dataText);
        return null;
    }

    return data;
};

/**
 * Transforma un objecte moment a un string amb el format definit a MASCARA_ISO_HHMM_Z.
 *
 * @param dataMoment {Moment}
 * @return {String}
 */
export const convertirMomentATextEnUTC = (dataMoment, mascara = MASCARA_ISO_HHMM_Z) => {
    return dataMoment.clone().utc().format(mascara);
};


/**
 * Transforma un objecte moment a un string amb el format definit a MASCARA_ISO_HHMM_Z.
 *
 * @param dataMoment {Moment}
 * @return {String}
 */
export const convertirMomentATextEnLocal = (data, mascara = MASCARA_ISO_HHMM_Z) => {
    return data.format(mascara);
};

// Valida si un objecte és un Moment
export const esDeTipusMoment = (objecte) => {
    return moment.isMoment(objecte);
};

export const esDataIniciPeriodeDeshabilitat = (dataCalendari, dataActual, dataFi, granuralitat) => {
    if (!dataCalendari) return false;

    const esDataFutura = dataCalendari.isAfter(dataActual, granuralitat);
    const esDataCalendariPosteriorADataInici = dataCalendari.isAfter(dataFi, granuralitat);

    return esDataFutura || esDataCalendariPosteriorADataInici;
};

/**
 *
 * @param {moment} dataCalendari
 * @param {moment} dataActual
 * @param {moment} dataInici
 * @param {string} granuralitat
 */
export const esDataFiPeriodeDeshabilitat = (dataCalendari, dataActual, dataInici, granuralitat) => {
    if (!dataCalendari) return false;

    const esDataFutura = dataCalendari.isAfter(dataActual, granuralitat);
    const esDataAnteriorADataFi = (dataInici) ? dataCalendari.isBefore(dataInici, granuralitat) : false;

    return esDataFutura || esDataAnteriorADataFi;
};

/**
 *
 * @param {moment} dataCalendari
 * @param {moment} dataActual
 * @param {string} granuralitat
 */
export const esDataValidaSelectorObservacions = (dataCalendari, dataActual, granuralitat) => {
    if (!dataCalendari || ! dataPassatNoMostrarSelectorObservacions) return false;

    const esDataFutura = dataCalendari.isAfter(dataActual, granuralitat);
    const esDataAnteriorADataFi = dataCalendari.isBefore(dataPassatNoMostrarSelectorObservacions, granuralitat);

    return esDataFutura || esDataAnteriorADataFi;
};



// WEBPACK FOOTER //
// ./src/commons/gestioDates.js